import * as angular from 'angular';

import { AlarmList } from '../../models/';
import { IDispatcherService, IDispatcher, IAlarmTemplateActionsService } from '../';

export interface IAlarmTemplateStoreService {
    getAll(): angular.IPromise<AlarmList>;
}

export interface IAlarmTemplateActionsDispatcherService extends IDispatcherService<IAlarmTemplateStoreService> { }

export class AlarmTemplateActionsDispatcherService implements IAlarmTemplateActionsDispatcherService {
    static serviceId = 'alarmTemplateActionsDispatcherService';

    static $inject = ['alarmTemplateActionsService'];

    constructor(private _actionService: IAlarmTemplateActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IAlarmTemplateStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getAll: () => dispatch(actionService.getAll())
            }
        };
    }
}